import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class DashboardUrlSiteAuditRoute extends Route {
  @service notifications;
  @service router;
  @service fetch;
  @service session;

  queryParams = {
    crawling_session_id: {
      refreshModel: true,
    },
    comparison_crawling_session_id: {
      refreshModel: true,
    },
  };

  activate() {
    window.scrollTo(0, 0);
  }

  beforeModel() {
    if (!this.session.user.siteAuditEnabled) {
      this.router.transitionTo('dashboard.url.site-audit-disabled');
    }
    this.notifications.info(
      '🚀 New High-Performance Crawler Launching Soon!\n' +
        'We’re rolling out a renewed version of our site audit crawler for faster and more accurate results.\n' +
        'We’ll notify you as soon as it’s live, stay tuned!'
    );
  }

  model() {
    const url = this.modelFor('dashboard.url');
    return {
      url,
    };
  }
}
